import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../redux/store';
import { UpdateTicketDto } from '../dto/ticket/update-ticket.dto';
import axios from '../utils/axios';

interface EventState {
    loading: boolean;
    idSelected: number;
    page: number;
    limit: number;
    total: number;
    tabSelected: number | 'all'
}

interface PageEventAction {
    page: number;
};

interface LimitEventAction {
    limit: number;
};

interface TotalEventAction {
    total: number;
};


interface LoadingAction {
    loading: boolean;
};

export const initialState: EventState = {
    loading: false,
    idSelected: 0,
    page: 0,
    limit: 10,
    total: 0,
    tabSelected: 'all'
};

const slice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        SET_PAGE_EVENT: (state: EventState, action: PayloadAction<PageEventAction>): EventState => {
            const { page } = action.payload;
            return {
                ...state,
                page
            };
        },
        SET_LIMIT_EVENT: (state: EventState, action: PayloadAction<LimitEventAction>): EventState => {
            const { limit } = action.payload;
            return {
                ...state,
                limit
            };
        },
        SET_TOTAL_EVENT: (state: EventState, action: PayloadAction<TotalEventAction>): EventState => {
            const { total } = action.payload;
            return {
                ...state,
                total
            };
        },
        LOADING_EVENT: (state: EventState, action: PayloadAction<LoadingAction>): EventState => {
            const { loading } = action.payload;
            return {
                ...state,
                loading
            };
        },
    }
});

export const reducer = slice.reducer;

export const getListAllEvents = async (page: number, limit: number): Promise<any> => {
    let output = null
    try {
        const response = await axios.get(`/api/ticket/list/me?page=${page}&size=${limit}`);
        output = response.data.payload;
    } catch (err) {
        console.error('listTicketsException', err);
    }

    return output;
}

export const getListAllEventsOperator = async (idProfile: number, page: number, limit: number): Promise<any> => {
    let output = null
    try {
        const response = await axios.get(`/api/ticket/list/operator/${idProfile}?page=${page}&size=${limit}`);
        output = response.data.payload;
    } catch (err) {
        output = null;
        console.error('listTicketsOperatorException', err);
    }

    return output;
}

export const getListAllEventsAdmin = async (page: number, limit: number): Promise<any> => {
    let output = null
    try {
        const response = await axios.get(`/api/ticket/list/all?page=${page}&size=${limit}`);
        output = response.data.payload;
    } catch (err) {
        console.error('listTicketsAdminException', err);
    }

    return output;
}

export const getListAllEventsBySearch = async (page: number, limit: number, id: number | string | boolean = '', category: string | number | boolean = '', status: string | number | boolean = ''): Promise<any> => {
    let output = null

    let url = `/api/ticket/search?page=${page}&size=${limit}`;

    if (id !== false && id !== '') {
        url = url + `&id=${id}`;
    }

    if (category !== false && category !== null) {
        url = url + `&categoria=${category}`;
    }

    if (status !== false && status !== null) {
        url = url + `&estado=${status}`;
    }


    try {
        const response = await axios.get(url);
        output = response.data.payload;
    } catch (err) {
        console.error('listTicketsSearchException', err);
    }

    return output;
}

export const getListNotificationsByProfile = async (idProfile: number, page: number, limit: number): Promise<any> => {
    let output = null
    try {
        const response = await axios.get(`/api/notification/profile/${idProfile}?page=${page}&size=${limit}`);
        output = response.data.payload;
    } catch (err) {
        console.error('listNotificationsException', err);
    }

    return output;
}

export const downloadReport = async (idProfile: number, month: number, year: number): Promise<any> => {
    let output = null
    try {
        const response = await axios.get(`/api/report/${idProfile}?month=${month}&year=${year}`, {
            responseType: 'blob',
        });
        output = response.data;
    } catch (err) {
        console.error('downloadReportException', err);
    }

    return output;
}

export const getListAllComments = async (idTicket: number, page: number, limit: number): Promise<any> => {
    let output = null
    try {
        const response = await axios.get(`/api/ticket/${idTicket}/comment?page=${page}&size=${limit}`);
        output = response.data.payload;
    } catch (err) {
        console.error('listTicketsCommentsOperatorException', err);
    }

    return output;
}

export const getListCategories = async (): Promise<any> => {
    let output = null

    try {
        const response = await axios.get('/api/ticket/category');
        output = response.data.payload;

    } catch (err) {
        console.error('listCategoriesException', err);
    }


    return output;
}

export const getListStatusEvents = async (): Promise<any> => {
    let output = null

    try {
        const response = await axios.get('/api/ticket/status');
        output = response.data.payload;

    } catch (err) {
        console.error('listCategoriesException', err);
    }


    return output;
}

export const getListOperators = async (): Promise<any> => {
    let output = null

    try {
        const response = await axios.get('/api/profile/operator');
        output = response.data.payload;

    } catch (err) {
        console.error('listCategoriesException', err);
    }


    return output;
}

export const updateEvent = async (data: UpdateTicketDto): Promise<any> => {
    const response = await axios.put('/api/ticket/' + data.id, {
        "description": data.description,
        "kilometer": data.kilometer,
        "sector": data.sector,
        "commune": data.commune,
        "orientation": data.orientation,
        "dateEvent": data.dateEvent,
        "classificationId": data.classificationId,
        "statusCode": data.statusCode,
        "assignedToId": data.assignedToId,
        "realAddress": data.realAddress,
        "email": data.email,
        "fullName": data.fullName,
        "phone": data.phone,
        "rut": data.rut,
        "patente": data.patente
    });

    return response;
}

export const changeStatusEvent = async (id: number, data: any, statusCode: string): Promise<any> => {
    const response = await axios.put(`/api/ticket/${id}`, {
        "statusCode": statusCode,
    });

    return response;
}

export const createComment = async (id: number, comment: string): Promise<any> => {
    const response = await axios.post(`/api/ticket/${id}/comment`, {
        "comment": comment,
    });

    return response;
}

export const getAttachmentEvent = async (id: BigInteger) => {
    let output = null

    try {
        const response = await axios.get(`api/ticket/${id}/attachment?page=0&size=100`);
        output = response.data.payload;

    } catch (err) {
        console.error('listCategoriesException', err);
    }


    return output;
}

export const getStatistic = async (): Promise<any> => {
    let output = null

    try {
        const response = await axios.get('/api/report/reportStatistic');

        output = response.data;

    } catch (err) {
        console.error('StatisticEventsError', err);
    }


    return output;
}

export const setLimit =
    (limit: number): AppThunk =>
        async (dispatch): Promise<void> => {
            dispatch(slice.actions.SET_LIMIT_EVENT({
                limit: limit
            }))
        };

export const setPage =
    (page: number): AppThunk =>
        async (dispatch): Promise<void> => {
            dispatch(slice.actions.SET_PAGE_EVENT({
                page: page
            }))
        };
export const setTotal =
    (total: number): AppThunk =>
        async (dispatch): Promise<void> => {
            dispatch(slice.actions.SET_TOTAL_EVENT({
                total: total
            }))
        };

export const setLoading =
    (flag: boolean): AppThunk =>
        async (dispatch): Promise<void> => {
            dispatch(slice.actions.LOADING_EVENT({
                loading: flag
            }))
        };

export default slice;